import { render } from "./Formato1953.vue?vue&type=template&id=58c9487f&scoped=true"
import script from "./Formato1953.vue?vue&type=script&lang=js"
export * from "./Formato1953.vue?vue&type=script&lang=js"

import "./Formato1953.vue?vue&type=style&index=0&id=58c9487f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c9487f"]])

export default __exports__